export default "__VITE_ASSET__l89LxHbB__"